import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0dea41e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f0dea41e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dea41e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\MyCode\\shop\\waynboot-mobile-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0dea41e')) {
      api.createRecord('f0dea41e', component.options)
    } else {
      api.reload('f0dea41e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f0dea41e&scoped=true", function () {
      api.rerender('f0dea41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackTop/index.vue"
export default component.exports